/* eslint-disable no-alert */
import React, { PropTypes, PureComponent } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { setPageInfo } from 'common/page/actions';
import { getProviders, createGetLocationFromUserDataAction } from 'common/actions/authenticationActions';
import { checkSWIDAuthentication } from 'common/actions/oneIdActions';
import { dateFormat } from 'lib/format';
import canUseDOM from 'lib/util/canUseDOM';
import injectIntl, { intlShape } from 'common/injectIntl';
import { userLocationSelector } from 'common/selectors/authenticationSelectors';
import { isDomesticSelector, locationSelector } from 'common/selectors/appSelector';

const styles = {
    container: {
        padding: 20,
        color: '#ddd',
        fontFamily: 'Arial',
        fontSize: 14
    },
    title: {
        display: 'block',
        marginBottom: 10,
        fontWeight: 'bold'
    },
    caption: {
        display: 'block',
        marginBottom: 20
    },
    alignRight: {
        textAlign: 'right'
    },
    requiredInput: {
        background: '#ffffcc',
        width: 290,
        height: 20,
        margin: 0,
        padding: 3,
        border: 'none'
    }
};

class Feedback extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            commentType: '',
            email: '',
            commentBody: '',
            platform: '',
            submitted: false
        };
        this.onFormChange = this.onFormChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(checkSWIDAuthentication());
        dispatch(createGetLocationFromUserDataAction());
    }

    onFormChange(event) {
        const state = event.target.getAttribute('data-state');
        this.setState({
            [state]: event.target.value
        });
    }

    onSubmit(event) {
        const { messages, intl: { formatMessage } } = this.props;
        const validationError = this.validationError;
        if (validationError) {
            event.preventDefault();
            const message = formatMessage(messages[`feedback.error.${validationError}`]);
            alert(message);
        }
    }

    get validationError() {
        if (!this.categorySelect.value) {
            return 'category';
        }
        if (!/^.+@.+\..+$/.test(this.emailInput.value)) {
            return 'email';
        }
        if (!this.commentText.value) {
            return 'comments';
        }
        return false;
    }

    render() {
        const { commentType, email, commentBody, platform, submitted } = this.state;
        const {
            currentLocation: {
                origin,
                pathname,
                search,
                hash,
                query
            },
            swid = '{}',
            userLocation = {},
            providers,
            isDomestic,
            messages,
            intl: { formatMessage }
        } = this.props;

        const {
            country = '',
            city = '',
            ip = ''
        } = userLocation;
        let inputs = [];
        if (canUseDOM) {
            const date = dateFormat.getDateTimeString(new Date(), 'dateTime4', 'America/New_York');
            const affIP = 'invalid';
            const channel = 'N/A';
            const userAgent = navigator.userAgent;
            const comment = `Comment type: ${commentType}
            Email: ${email}
            Date: ${date}
            Feedback source: watchespn
            JavaScript: on
            Cookies: ${document.cookie.length > 0 ? 'on' : 'off'}
            Screen: ${screen.width}x${screen.height}
            IP: ${ip}
            Affiliate ${affIP}
            MVPD/Authentication:
            Country: ${country}
            City: ${city}
            User agent: ${userAgent}
            Platform: ${platform}
            SWID: ${swid}

            Comment: ${commentBody}`;

            inputs = [
                <input type="hidden" name="orgid" value="00D4000000080H6" />,
                <input
                    type="hidden"
                    name="retURL"
                    value={`${origin}${pathname}${search}${search ? '&' : '?'}submitted=true${hash}`}
                />,
                <input id="00N40000001cOWA" name="00N40000001cOWA" type="hidden" value={affIP} maxLength="100" />,
                <input id="00N40000002GQZZ" name="00N40000002GQZZ" type="hidden" value={channel} maxLength="30" />,
                <input id="00N40000001cOWK" name="00N40000001cOWK" type="hidden" value={userAgent} maxLength="100" />,
                <input id="00N40000001Tm8o" name="00N40000001Tm8o" type="hidden" value="Desktop WatchESPN" />,
                <input id="00N40000001thXQ" name="00N40000001thXQ" type="hidden" value={comment} />,
                <input id="00N40000001vpue" name="00N40000001vpue" type="hidden" value={swid} />,
                <input id="type" name="type" type="hidden" value="Desktop WatchESPN" />,
                <input id="subject" name="subject" type="hidden" value="WatchESPN Desktop Feedback" />
            ];
        }

        const providerOptions = providers.map(({ name, abbreviation }) => (
            <option value={abbreviation}>{name}</option>
        ));
        providerOptions.unshift(
            <option value="default">
                {`----- ${formatMessage(messages['feedback.provider.default'])} -----`}
            </option>
        );
        return (
            <div style={styles.container}>
                <Helmet
                    meta={[
                        { name: 'robots', content: 'noindex, nofollow' }
                    ]}
                    style={[{
                        cssText: `
                            body {
                                margin: 0;
                                padding: 0;
                                background: #000;
                            }
                        `
                    }]}
                    script={isDomestic ? [
                        { innerHTML: `
                            (function() {
                                function onZopimLoad() {
                                    if ($zopim) {
                                        $zopim.livechat.window.onShow(function() {
                                            $zopim.livechat.window.hide();
                                            $zopim.livechat.window.openPopout();
                                        });
                                    }
                                }

                                window.$zopim || (function(d, s) {
                                    var z = $zopim = function(c) {
                                            z._.push(c)
                                        },
                                        $ = z.s = d.createElement(s),
                                        e = d.getElementsByTagName(s)[0];
                                    z.set = function(o) {
                                        z.set._.push(o)
                                    };
                                    z._ = [];
                                    z.set._ = [];
                                    $.async = !0;
                                    $.setAttribute("charset", "utf-8");
                                    $.src = "//v2.zopim.com/?3X1YqOhMC21Mp5TuhBplWWY473rBk06l";
                                    z.t = +new Date;
                                    $.type = "text/javascript";
                                    $.onload = onZopimLoad;
                                    e.parentNode.insertBefore($, e)
                                })(document, "script");
                            })();
                        ` }
                    ] : []}
                />
                {(submitted || query.submitted) ? (
                    <div>
                        <span style={styles.caption}>{formatMessage(messages['feedback.thankYou'])}</span>
                    </div>
                ) : (
                    <div>
                        <span style={styles.title}>{formatMessage(messages['feedback.title'])}</span>
                        <span style={styles.caption}>{formatMessage(messages['feedback.caption'])}</span>
                        <form
                            name="postFeedback"
                            action="https://www.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8"
                            method="post"
                            onSubmit={this.onSubmit}
                        >
                            {inputs}
                            <table cellPadding="4" cellSpacing="0">
                                <tbody>
                                    <tr>
                                        <td style={styles.alignRight}>
                                            {formatMessage(messages['feedback.category'])}:
                                        </td>
                                        <td>
                                            <select
                                                ref={select => { this.categorySelect = select; }}
                                                id="00N400000034PSb"
                                                name="00N400000034PSb"
                                                size="1"
                                                style={styles.requiredInput}
                                                defaultValue=""
                                                data-state="commentType"
                                                onChange={this.onFormChange}
                                            >
                                                <option value="">
                                                    {formatMessage(messages['feedback.category.select'])}
                                                </option>
                                                <option value="0001">
                                                    {formatMessage(messages['feedback.category.userExperience'])}
                                                </option>
                                                <option value="0002">
                                                    {formatMessage(messages['feedback.category.videoPerformance'])}
                                                </option>
                                                <option value="0003">
                                                    {formatMessage(messages['feedback.category.programming'])}
                                                </option>
                                                <option value="0004">
                                                    {formatMessage(messages['feedback.category.other'])}
                                                </option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.alignRight}>
                                            {formatMessage(messages['feedback.email'])}:
                                        </td>
                                        <td>
                                            <input
                                                ref={input => { this.emailInput = input; }}
                                                type="text"
                                                style={styles.requiredInput}
                                                id="email"
                                                name="email"
                                                size="30"
                                                maxLength="40"
                                                value={email}
                                                data-state="email"
                                                onChange={this.onFormChange}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.alignRight}>
                                            {formatMessage(messages['feedback.provider'])}:
                                        </td>
                                        <td>
                                            <select
                                                id="00N40000002G61X"
                                                name="00N40000002G61X"
                                                size="1"
                                                defaultValue="default"
                                            >
                                                {providerOptions}
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={styles.alignRight}>
                                            {formatMessage(messages['feedback.platform'])}:
                                        </td>
                                        <td>
                                            <select
                                                size="1"
                                                defaultValue="Desktop/laptop"
                                                data-state="platform"
                                                onChange={this.onFormChange}
                                            >
                                                <option value="Desktop/laptop">
                                                    {formatMessage(messages['feedback.desktoplaptop'])}
                                                </option>
                                                <option value="iPhone">
                                                    {formatMessage(messages['feedback.iphone'])}
                                                </option>
                                                <option value="iPad">
                                                    {formatMessage(messages['feedback.ipad'])}
                                                </option>
                                                <option value="Android Phone">
                                                    {formatMessage(messages['feedback.androidphone'])}
                                                </option>
                                                <option value="Android Tablet">
                                                    {formatMessage(messages['feedback.androidtablet'])}
                                                </option>
                                                <option value="Xbox One">
                                                    {formatMessage(messages['feedback.xbox'])}
                                                </option>
                                                <option value="PlayStation">
                                                    {formatMessage(messages['feedback.playstation'])}
                                                </option>
                                                <option value="Apple TV">
                                                    {formatMessage(messages['feedback.appletv'])}
                                                </option>
                                                <option value="Android TV">
                                                    {formatMessage(messages['feedback.androidtv'])}
                                                </option>
                                                <option value="Amazon FireTV">
                                                    {formatMessage(messages['feedback.amazonfiretv'])}
                                                </option>
                                                <option value="Chromecast">
                                                    {formatMessage(messages['feedback.chromecast'])}
                                                </option>
                                                <option value="Roku">
                                                    {formatMessage(messages['feedback.roku'])}
                                                </option>
                                            </select>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style={{ ...styles.alignRight, verticalAlign: 'top' }}>
                                            {formatMessage(messages['feedback.comments'])}:
                                        </td>
                                        <td>
                                            <textarea
                                                ref={input => { this.commentText = input; }}
                                                id="description"
                                                name="description"
                                                style={{ ...styles.requiredInput, height: 60 }}
                                                cols="28"
                                                rows="3"
                                                wrap="virtual"
                                                value={commentBody}
                                                data-state="commentBody"
                                                onChange={this.onFormChange}
                                            />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td />
                                        <td>
                                            <input type="submit" value={formatMessage(messages['feedback.send'])} />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                )}
            </div>
        );
    }
}

Feedback.propTypes = {
    dispatch: PropTypes.func,
    currentLocation: PropTypes.object,
    swid: PropTypes.string,
    userLocation: PropTypes.object,
    providers: PropTypes.arrayOf(PropTypes.object),
    isDomestic: PropTypes.bool,
    intl: intlShape.isRequired,
    messages: PropTypes.object.isRequired
};

Feedback.loadActions = [
    () => getProviders(),
    () => setPageInfo('feedback', 'Feedback')
];

const mapStateToProps = (state) => {
    const { oneId: { swid } = {} } = state;
    const userLocation = userLocationSelector(state);
    const { providerDialog: { providers = [] } = {} } = state;
    const currentLocation = locationSelector(state);
    const isDomestic = isDomesticSelector(state);
    return {
        currentLocation,
        swid,
        userLocation,
        providers,
        isDomestic
    };
};

export default connect(mapStateToProps)(injectIntl(Feedback));



// WEBPACK FOOTER //
// ./app/webapp/page/Feedback.js